import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/img/logo.jpg'


const _withScopeId = n => (_pushScopeId("data-v-27331160"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<head data-v-27331160><meta charset=\"UTF-8\" data-v-27331160><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\" data-v-27331160><meta http-equiv=\"X-UA-Compatible\" content=\"ie=edge\" data-v-27331160><title data-v-27331160>Protocolo SuportDOC</title><meta name=\"description\" content=\"Protocolo de entrega Grupo Suport\" data-v-27331160><meta name=\"keywords\" content=\"\" data-v-27331160><meta name=\"author\" content=\"OnixSS\" data-v-27331160><link rel=\"manifest\" href=\"../public/icon/manifest.json\" data-v-27331160></head>", 1)
const _hoisted_2 = { class: "flex-1 bg-hero bg-cover bg-center bg-no-repeat bg-fixed min-h-screen" }
const _hoisted_3 = {
  key: 0,
  class: "bg-blue-500 text-white py-3 px-4 rounded-lg shadow-lg mx-4 mt-16 md:mt-20 fixed top-0 left-0 right-0 z-40 flex items-center justify-between gap-4"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm md:text-base flex-1" }, "Instale esse aplicativo no seu celular sem ocupar espaço. Isso facilita o acesso.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "mx-auto max-w-7xl px-2 sm:px-6 lg:px-8" }
const _hoisted_8 = { class: "relative flex h-16 items-center justify-between" }
const _hoisted_9 = { class: "absolute inset-y-0 left-0 flex items-center sm:hidden" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Abrir menu", -1))
const _hoisted_11 = { class: "flex flex-1 items-center justify-center sm:items-stretch sm:justify-start" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-shrink-0 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-10 md:h-14",
    src: _imports_0,
    alt: "SuportDOC"
  })
], -1))
const _hoisted_13 = { class: "hidden sm:ml-6 sm:block w-full" }
const _hoisted_14 = { class: "flex space-x-4 justify-end" }
const _hoisted_15 = { class: "space-y-1 px-2 pt-2 pb-3 bg-white" }
const _hoisted_16 = { class: "pt-20 pb-3" }
const _hoisted_17 = { class: "fixed bottom-0 left-0 right-0 bg-gray-100 text-gray-500 text-xs py-1 text-center" }


import { defineComponent } from 'vue';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue';
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';

// Interface para tipar o evento PWA (para evitar erros TS)
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

const __default__ = defineComponent({
  data() {
    return {
      deferredPrompt: null as BeforeInstallPromptEvent | null,
      appVersion: process.env.VUE_APP_VERSION || 'Desconhecida',
      showPWAInstall: true, // Controla visibilidade da notificação
    };
  },
  created(): void {
    console.log('App version:', this.appVersion);

    // Verifica se a notificação foi fechada anteriormente
    if (localStorage.getItem('pwaInstallDismissed') === 'true') {
      this.showPWAInstall = false;
    }

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e as BeforeInstallPromptEvent;
    });

    window.addEventListener('appinstalled', () => {
      this.deferredPrompt = null;
      this.showPWAInstall = false; // Esconde após instalação
    });
  },
  methods: {
    async dismiss() {
      this.showPWAInstall = false;
      localStorage.setItem('pwaInstallDismissed', 'true'); // Persiste a escolha
    },
    async install() {
      if (this.deferredPrompt) {
        await this.deferredPrompt.prompt();
        const { outcome } = await this.deferredPrompt.userChoice;
        if (outcome === 'accepted') {
          console.log('PWA instalado!');
        } else {
          console.log('Instalação cancelada.');
        }
        this.deferredPrompt = null;
        this.showPWAInstall = false;
      }
    },
  },
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'App',
  setup(__props) {

const navigation = [
  { name: 'Home', href: '/', current: false },
  // Adicione mais itens se necessário, ex: { name: 'Sair', href: '/sair', current: false }
];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("body", _hoisted_2, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_ctx.showPWAInstall && _ctx.deferredPrompt)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.install && _ctx.install(...args))),
                  class: "bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-lg text-xs md:text-sm transition duration-100"
                }, "Instalar"),
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args))),
                  class: "text-white hover:text-gray-300 transition duration-100",
                  "aria-label": "Fechar notificação"
                }, _hoisted_6)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_unref(Disclosure), {
        as: "nav",
        class: "w-full bg-white py-2 fixed z-30 top-0 shadow-md"
      }, {
        default: _withCtx(({ open }) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(DisclosureButton), { class: "inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-400" }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    (!open)
                      ? (_openBlock(), _createBlock(_unref(Bars3Icon), {
                          key: 0,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                      : (_openBlock(), _createBlock(_unref(XMarkIcon), {
                          key: 1,
                          class: "block h-6 w-6",
                          "aria-hidden": "true"
                        }))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                      return _createVNode(_component_router_link, {
                        key: item.name,
                        to: item.href,
                        class: _normalizeClass([item.current ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100', 'rounded-md px-3 py-2 text-md font-medium transition duration-100']),
                        "aria-current": item.current ? 'page' : undefined
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "class", "aria-current"])
                    }), 64))
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(_unref(DisclosurePanel), { class: "sm:hidden" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
                  return _createVNode(_component_router_link, {
                    key: item.name,
                    to: item.href,
                    class: _normalizeClass([item.current ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600 hover:bg-gray-100', 'block rounded-md px-3 py-2 text-md font-medium transition duration-100']),
                    "aria-current": item.current ? 'page' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class", "aria-current"])
                }), 64))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("main", _hoisted_16, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("footer", _hoisted_17, " V: " + _toDisplayString(_ctx.appVersion), 1)
    ])
  ], 64))
}
}

})